import Axios from 'axios';
import { getEndpointURL } from './config';
Axios.defaults.withCredentials = true;

const endpointURL = getEndpointURL();
const headers = { 'Content-Type': 'application/json; charset=utf-8' };

const GetCompany = async (searchCompany, rowsPerPage, page) => {
    return Axios({
        method: 'POST',
        headers,
        data: { searchCompany, rowsPerPage, page },
        url: `${endpointURL}/api/company/get-company`
    })
}

const CreateNewCompany = async (companyInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: { companyInfor },
        url: `${endpointURL}/api/company/create-new-company`
    })
}

const UpdateCompany = async (companyInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: { companyInfor },
        url: `${endpointURL}/api/company/update-company`
    })
}

const InactiveCompany = async (selected) => {
    return Axios({
        method: 'POST',
        headers,
        data: { selected },
        url: `${endpointURL}/api/company/inactive-company`
    })
}
const ActiveCompany = async (selected) => {
    return Axios({
        method: 'POST',
        headers,
        data: { selected },
        url: `${endpointURL}/api/company/active-company`
    })
}
const DeleteCompany = async (selected) => {
    return Axios({
        method: 'POST',
        headers,
        data: { selected },
        url: `${endpointURL}/api/company/delete-company`
    })
}

export {
    GetCompany,
    CreateNewCompany,
    UpdateCompany,
    InactiveCompany,
    ActiveCompany,
    DeleteCompany,
};
